module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-slider-5.jpg?d1e8ce6d";